import React, { Component } from 'react';
import Head from 'next/head';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import TagManager from 'react-gtm-module';
const tagManagerArgs = {
  gtmId: 'GTM-T6NLBBR'
}
class pageHead extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-78527817-1"></script>
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'UA-78527817-1');
    TagManager.initialize(tagManagerArgs)
  }
  render() {
console.log(this.props.meta, "this.props.meta")
    return (
      <div>
       <Head>
          <title>{this.props.meta ? this.props.meta.metatitle : this.props.title ? this.props.title : 'Gadget zippy'}</title>
          <link rel="icon" href={`${publicRuntimeConfig.staticFolder}/images/favicon.png`} />
          <link rel="canonical" href={this.props.canonical ? this.props.canonical : 'http://gadgetzippy.com/'} key="canonical" />
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
          <meta id="english-canonical-url" content="" />
          {/* <meta name="title" content={this.props.meta ? this.props.meta.metatitle : 'Gadget zippy'} /> */}
          <meta name="description" content={this.props.meta ? this.props.meta.metaDescription : 'Gadget zippy'} />
          <meta name="keywords" content={this.props.meta ? this.props.meta.metaKeywords : 'Gadget zippy'} /> 
          {this.props.facebookmeta ? <meta name="facebook-domain-verification" content={this.props.facebookmeta} />:''}
          {/* <meta property="og:title" content="Gadgetzippy"  />
            <meta property="og:type" content="website"  />
            <meta property="og:image" content="https://pmj-internal-media.s3.ap-south-1.amazonaws.com/gadgetzippy/gzog.png"/>
+            <meta property="og:url" content="https://www.gadgetzippy.com/"/>
            <meta property="og:description" content=""  />
            <meta property="og:site_name" content=""  />
          <meta name="twitter:widgets:csp" content="on" /> */}
          <meta property="og:url" content="https://www.gadgetzippy.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Apple iPhone, iPad, iWatch &amp; MacBook Repair &amp; Service Center Near Me" />
        <meta property="og:description" content="Most Trusted iPhone, iPad, iWatch, MacBook Repair Service across 12 Cities in India. Fastest iPhone Screen & Display Repairs Done in 20 Mins at Your Doorstep." />
        <meta property="og:image" content="https://pmj-internal-media.s3.ap-south-1.amazonaws.com/gadgetzippy/gzog.png" />
        <meta property="twitter:url" content="https://www.gadgetzippy.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Apple iPhone, iPad, iWatch &amp; MacBook Repair &amp; Service Center Near Me" />
        <meta name="twitter:description" content="Most Trusted iPhone, iPad, iWatch, MacBook Repair Service across 12 Cities in India. Fastest iPhone Screen & Display Repairs Done in 20 Mins at Your Doorstep." />
        <meta name="twitter:image" content="https://pmj-internal-media.s3.ap-south-1.amazonaws.com/gadgetzippy/gzog.png" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
           <meta name="google-site-verification" content="I3fsGc8bimrWtQI2ZYAM6Cs9JwqzQXbRRAlHrFqvQdQ" />
        </Head>
      </div>
    );
  }
}
export default pageHead;
